import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按类型浏览海量剧集资源，总有一个专题戳中你的追剧口味
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {indexData.map((item) => (
            <a
              key={item.id}
              href={item.link}
              className="group flex items-center gap-4 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-500/30 hover:-translate-y-0.5 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-primary-500/10 flex-shrink-0 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-lg md:text-xl text-primary-400`}></i>
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-0.5 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 truncate">{item.desc}</p>
              </div>
              <span className="text-xs font-medium text-foreground-500 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap flex-shrink-0">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}